module.exports = __webpack_public_path__ + "static/media/presensi_siswa.587f6e5e.png";